/**
 * Created by zuozhuo on 2018/3/31.
 */

/* eslint-disable import/no-webpack-loader-syntax */
import lazyVConsole from "bundle-loader?lazy!vconsole";
import storeDebugSettings from "../store/storeDebugSettings";
import $script from "scriptjs";
import { WeinreServerURL } from "../consts/consts";

function onVConsoleReady() {
  return new Promise((resolve, reject) => {
    if (storeDebugSettings.vconsole) {
      lazyVConsole(VConsole => {
        new VConsole();
        resolve();
      });
    } else {
      resolve();
    }
  });
}

function onWeinreReady() {
  return new Promise((resolve, reject) => {
    if (storeDebugSettings.weinre) {
      // 这里必须写入, 因为 target-script-min.js 需要用到
      window.WeinreServerURL = WeinreServerURL;
      $script(
        [`${window.WeinreServerURL}target/target-script-min.js#anonymous`],
        resolve
      );
    } else {
      resolve();
    }
  });
}

function onReady(callback) {
  Promise.all([onVConsoleReady(), onWeinreReady()]).then(callback);
}

export default {
  onReady
};



// WEBPACK FOOTER //
// ./src/utils/debugTools.js